export default __webpack_public_path__ + "static/media/reach.cd93bade.svg";